module.exports = __webpack_public_path__ + "img/basic-account.abf54ea5.png";